export default {
    "finding": "name",
    "function" : "NIST Function",
    "category": "NIST Category",
    "probability": "Probability",
    "impact": "Impact",
    "overall": "Overall",
    "recommendation": "Recommendation",
    "references": "References"
}